import { FC, HTMLAttributes, useRef } from "react";
import clsx from "classnames";
import { useStyles } from "./ProgressBar.styles";

type ProgressBarSize = "small" | "medium" | "large" | "extraLarge";

interface IProgressBarProps {
  color: string;
  progress?: number;
  size?: ProgressBarSize;
}

export const ProgressBar: FC<
  IProgressBarProps & HTMLAttributes<HTMLDivElement>
> = ({ size = "small", progress, color, ...otherProps }) => {
  const classes = useStyles();
  const refBar = useRef<HTMLDivElement>(null);

  return (
    <div
      {...otherProps}
      className={clsx(classes.root, otherProps.className, size)}
    >
      <div
        ref={refBar}
        style={{
          width: `${progress}%`,
          background: color,
        }}
        className={clsx(classes.bar, size)}
      />
    </div>
  );
};
